import { styled } from '@mui/system';
import { Typography, Divider } from '@mui/material';
import { Preloader } from '#component/preloader';
import DeviceIcon from '#component/icon/device-icon';

export const TooltipContainer = styled('div')(() => ({
  textAlign: 'left',
  minWidth: 150
}));

export const StyledPreloader = styled(Preloader)(({ theme }) => ({
  marginTop: theme.spacing(1)
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.dark
}));

export const TempContainer = styled(Typography)(() => ({
  '& svg': {
    verticalAlign: 'bottom'
  }
}));

export const ChargeContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontWeight: 400,
  fontSize: '1rem'
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: 4,
  marginBottom: 4,
  backgroundColor: theme.palette.common.white
}));

export const LabelContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(1),
  '& p': {
    lineHeight: '26px',
    color: theme.palette.common.white
  }
}));

export const ActiveInTitle = styled(Typography)(() => ({
  maxWidth: 230
}));

export const TimestampContainer = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white
}));

export const Timestamp = styled('span')(() => ({
  whiteSpace: 'nowrap'
}));

export const StyledDeviceIcon = styled(DeviceIcon)(({ theme }) => ({
  marginRight: 4,
  color: `${theme.palette.common.white} !important`
}));
